var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRowArrowUp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.6036 10.6036C13.43 10.7771 13.1606 10.7964 12.9657 10.6614L12.8964 10.6036L7.75 5.457L2.60355 10.6036C2.42999 10.7771 2.16056 10.7964 1.96569 10.6614L1.89645 10.6036C1.72288 10.43 1.7036 10.1606 1.83859 9.96569L1.89645 9.89645L7.39645 4.39645C7.57001 4.22288 7.83944 4.2036 8.03431 4.33859L8.10355 4.39645L13.6036 9.89645C13.7988 10.0917 13.7988 10.4083 13.6036 10.6036Z",
    fill: "#1E2447",
    stroke: "#1E2447",
    strokeWidth: 0.8
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRowArrowUp);
export default __webpack_public_path__ + "static/media/row-arrow-up.f3f26ba7.svg";
export { ForwardRef as ReactComponent };